export const VERIFICATION_STEP = {
  CHOOSE_METHOD: 0,
  ENTER_OTP: 1,
  ENTER_TWO_FA: 2,
};